/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: useDebugMode.ts (Debug Mode Hook)
 🗓️ Created: 2025-01-22
 🧩 Description:
    Custom hook for Debug Mode functionality.
    Provides easy access to debug mode state and actions.

 🔧 Notes:
    - Wraps the debug mode store for easier usage
    - Provides reactive updates
    - Handles permission checking

 🔁 Last Updated: 2025-01-22 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { useDebugModeStore } from '../store/debugMode';

export const useDebugMode = () => {
  const { isActive, hasPermission, setDebugMode, toggleDebugMode, initializeFromUser, syncWithUser } = useDebugModeStore();

  return {
    // State
    isActive,
    hasPermission,
    
    // Actions
    setDebugMode,
    toggleDebugMode,
    initializeFromUser,
    syncWithUser,
    
    // Computed
    canToggle: hasPermission,
    isEnabled: isActive && hasPermission,
    
    // Helper methods
    isDebugModeActive: isActive && hasPermission,
    canUseDebugFeatures: hasPermission
  };
};
